import React from 'react';
import { Proposal } from '../../hooks/useProposals'; // Changed from Project
// Paths will be to the new proposal-specific components
import ProposalFilters from './ProposalFilters';
import ProposalCardView from './ProposalCardView';
import ProposalTableView from './ProposalTableView';

export type ViewMode = 'cards' | 'table';

// Placeholder Client interface - ideally this comes from a types file or useClients hook
interface Client {
    id: string;
    name: string;
}

interface ProposalListProps { // Renamed from ProjectListProps
    filteredProposals: Proposal[]; // Renamed from filteredProjects
    clients: Client[]; // Added for client name lookup
    loadingClients?: boolean; // Added
    viewMode: ViewMode;
    showLeadsOnly: boolean;
    getTypeName: (typeId: string) => string;
    getTechnologyName: (techId: string) => string;
    getSeniorityName: (seniorityId: string) => string;
    formatDate: (dateString: string) => string;
    handleEdit: (proposal: Proposal) => void; // Changed from project: Project
    handleDelete: (proposalId: string) => void; // Changed from projectId: string
    setSelectedProposalForDetails: (proposal: Proposal | null) => void; // Changed from project: Project | null
    setShowLeadsOnly: (show: boolean) => void;
    setIsFilterModalOpen: (isOpen: boolean) => void;
    setViewMode: (mode: ViewMode) => void;
    isMobile: boolean;
}

export default function ProposalList({ // Renamed from ProjectList
    filteredProposals, // Renamed
    clients,           // Added
    loadingClients,    // Added
    viewMode,
    showLeadsOnly,
    getTypeName,
    getTechnologyName,
    getSeniorityName,
    formatDate,
    handleEdit,
    handleDelete,
    setSelectedProposalForDetails,
    setShowLeadsOnly,
    setIsFilterModalOpen,
    setViewMode,
    isMobile
}: ProposalListProps) {
    return (
        <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
                <ProposalFilters // Renamed from ProjectFilters
                    showLeadsOnly={showLeadsOnly}
                    setShowLeadsOnly={setShowLeadsOnly}
                    setIsFilterModalOpen={setIsFilterModalOpen}
                    viewMode={viewMode}
                    setViewMode={setViewMode}
                    isMobile={isMobile}
                />

                <div className="mt-5">
                    {filteredProposals.length === 0 ? ( // Renamed
                        <p className="text-gray-500">Nenhuma proposta encontrada.</p> // Text updated
                    ) : viewMode === 'cards' ? (
                        <ProposalCardView // Renamed from ProjectCardView
                            proposals={filteredProposals} // Renamed from projects
                            clients={clients}           // Added
                            loadingClients={loadingClients} // Added
                            formatDate={formatDate}
                            getTypeName={getTypeName}
                            getTechnologyName={getTechnologyName}
                            getSeniorityName={getSeniorityName}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        // setSelectedProposalForDetails is not used by CardView directly in original code
                        />
                    ) : (
                        <ProposalTableView // Renamed from ProjectTableView
                            proposals={filteredProposals} // Renamed from projects
                            clients={clients}           // Added
                            loadingClients={loadingClients} // Added
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            setSelectedProposalForDetails={setSelectedProposalForDetails} // Renamed
                        />
                    )}
                </div>
            </div>
        </div>
    );
} 